import { useCallback, useEffect, useMemo, useState } from "react";
import Divider from "../../../../../../../../components/Divider/Divider";
import FlexColumn from "../../../../../../../../components/FlexBox/FlexColumn";
import FlexRow from "../../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../../components/SButton/SButton";
import Typography from "../../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../../styles/colors";
import TextInput from "../../../../../../../../components/Inputs/TextInput";
import Dropdown from "../../../../../../../../components/Inputs/Dropdown";
import { AZURE_ZKTECO_CONTROLLER_CONFIGS, DCS_CONTROLLER_CONFIGS, ISTAR_CONTROLLER_CONFIGS, OTHERS_CONTROLLER_CONFIGS, SPINTLY_CONTROLLER_CONFIGS } from "../../../../../../../../constants/list/AccessPointTypeList";
import Checkbox from "../../../../../../../../components/Inputs/Checkbox/Checkbox";
import { allCredTypes, credsTypesMap } from "../../../../../../../../utils/Common";
import { doGetSupportedAccessTypes } from "../../../../../../../../redux/thunks/controllers";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import CredentialLoaders from "../../SkeletonLoaders/CredentialLoaders";
import Switch from "../../../../../../../../components/Inputs/Switch/Switch";
import Radio from "../../../../../../../../components/Inputs/Radio/Radio";
import { CaretDownIcon, CaretUpIcon, TrashIcon } from "@phosphor-icons/react";

const INCORRECT_ERROR = "Serial number doesn't support the configuration";

const Door = ({ doorCount, accessPointDetails, allDoors, ap, setDoors, channelsMap, setChannelsMap, editModeChannelOptions }) => {
    const { customerId } = useParams();
    const dispatch = useDispatch();

    const channelOptions = useMemo(() => {
        const options = [];
        for (let i = 0; i < accessPointDetails?.noOfControllerChannels; i++) {
            options.push(`Main Board - R${i + 1}`);
        }

        for (let i = 0; i < accessPointDetails?.boards?.length; i++) {
            const board = accessPointDetails?.boards[i];

            for (let j = 0; j < Number(board.channels); j++) {
                options.push(`Downstream Board ${board?.port} - R${j + 1}`);
            }
        }
        return options
    }, [ap, accessPointDetails?.noOfControllerChannels])

    useEffect(() => {
        if (ap?.supportedAccessType) {
            let bits = Number(ap?.supportedAccessType)?.toString(2);
            if (bits?.length > 3) {
                bits = bits.slice(0, -5) + bits.slice(-3)
            }
            const validCredTypes = [];
            const tempCheckedCredType = {
                ...ap?.checkedCredTypes
            }

            for (let i = 0; i < allCredTypes?.length; i++) {
                if (bits[bits?.length - 1 - i] === "1") {
                    validCredTypes?.push(allCredTypes[i]);
                    tempCheckedCredType[allCredTypes[i]?.id] = true
                } else {
                    tempCheckedCredType[allCredTypes[i]?.id] = false
                }
            }
            hUpdateForm("checkedCredTypes", tempCheckedCredType)
            hUpdateForm("credTypes", validCredTypes);
        }
    }, [ap?.supportedAccessType])


    useEffect(() => {
        if (ap?.entryDeviceSerialNum?.error === "" && ap?.entryDeviceSerialNum?.value?.length === 14) {
            hUpdateForm("inProgress", true);
            dispatch(doGetSupportedAccessTypes(
                customerId,
                ap?.entryDeviceSerialNum?.value,
                (data) => {
                    if (data?.message?.showCredentialTypes === false) {
                        hUpdateForm("credentialNotSupported", true);
                    }
                    // if (data?.message?.showWireProtocol === false) {
                    //     setWireProtocolNotSupported(true)
                    // }
                    hUpdateForm("supportedAccessType", data?.message?.supportedAccessType)
                    hUpdateForm("inProgress", false);
                },
                () => { }
            ));
        }
    }, [ap?.entryDeviceSerialNum?.value, ap?.entryDeviceSerialNum?.error])

    function checkError(value, field) {
        if (field === 'entry') {
            if (!ap?.configuration?.validSerials?.entry?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
        if (field === 'exit') {
            if (!ap?.configuration?.validSerials?.exit?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
        if (field === 'controller') {
            if (!ap?.configuration?.validSerials?.control?.includes(value?.substring(0, 4))) {
                return INCORRECT_ERROR;
            } else if (value.length !== 14) {
                return 'Please enter a valid Serial Number';
            } else {
                return '';
            }
        }
    }

    const handleSerialDescription = (value, field) => {
        const switchCase = value.substring(0, 4);
        let description = '';
        switch (String(switchCase)) {
            case '1001':
            case '1002':
            case '1016':
            case '101F':
            case '1021':
            case '1026':
            case '1032':
            case '1028':
            case '1029':
            case '1033':
            case '1034':
            case '103B':
            case '103A':
                description = 'Mobile/Card';
                break;
            case '1023':
            case '1015':
                description = 'Mobile/Card/Fingerprint';
                break;
            case '1024':
            case '1025':
            case '103D':
            case '102F':
                description = 'Face/Card';
                break;
            case '1027':
                description = 'Mobile';
                break;
            case '1038':
                description = 'Mobile/QR/Card';
                break;
            default:
                break;
        }

        let error = '';

        error = checkError(value, field)

        if (field === 'entry') {
            hUpdateForm("entryDeviceSerialNum", { ...ap?.entryDeviceSerialNum, description: description, value: value?.trim(), error: error });
        }
        if (field === 'exit') {
            hUpdateForm("exitDeviceSerialNum", { ...ap?.exitDeviceSerialNum, description: description, value: value?.trim(), error: error });
        }
    };

    const hToggleCredTypes = (name, value, isCommonCred) => {
        if (isCommonCred) {
            hUpdateForm("checkedCommonCred", {
                ...ap?.checkedCommonCred,
                [name]: value,
                count: value ? ap?.checkedCommonCred?.count + 1 : ap?.checkedCommonCred?.count - 1
            })
        } else {
            if (value === false) {
                hUpdateForm("checkedCommonCred", {
                    ...ap?.checkedCommonCred,
                    [name]: value,
                    count: ap?.checkedCommonCred?.count - 1
                })
            }
            hUpdateForm("checkedCredTypes", {
                ...ap?.checkedCredTypes,
                [name]: value
            })
        }
    }

    const setRelayValue = useCallback((value) => {
        if (value <= 240) {
            hUpdateForm("relayTime", value);
        }
    }, []);

    const selectLockingMechanism = useCallback((data) => {
        hUpdateForm("relayTime", data?.relayTime ? data?.relayTime : 0);
        hUpdateForm("lockingMech", { name: data.name, value: data.value });
    }, []);

    const renderRelayTime = useCallback(() => {
        return (
            <FlexColumn styles={{ background: colors.grey025, padding: '1rem', borderRadius: '0.5rem' }}>
                <FlexRow justifyContent="space-between">
                    <Typography variant={"b1SB"} color={colors.info500}>{ap?.configuration?.value === 6 ? 'Door Settings' : 'Relay Settings'}</Typography>
                    {ap?.configuration?.value !== 6 ? (
                        <>
                            {ap?.lockingMech?.name === '' && ap?.configuration?.formOptions?.relayTime ? (
                                <Typography variant={"b3R"} color={colors.error500}>No locking mechanism selected</Typography>
                            ) : (
                                <>
                                    {ap?.configuration?.formOptions?.relayTime ? (
                                        <SButton
                                            onClick={(e) => {
                                                hUpdateForm("toggleRelaytime", !ap?.toggleRelaytime);
                                            }}
                                            size="small"
                                            variant="secondary"
                                        >{ap?.toggleRelaytime ? "Hide Details" : "Show Details"}</SButton>
                                    ) : (
                                        <Typography variant={"b3R"} color={colors.error500}>No settings available</Typography>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <SButton
                            onClick={(e) => {
                                hUpdateForm("toggleRelaytime", !ap?.toggleRelaytime);
                            }}
                            size="small"
                            variant="secondary"
                        >{ap?.toggleRelaytime ? "Hide Details" : "Show Details"}</SButton>
                    )}
                </FlexRow>

                {ap?.toggleRelaytime && (ap?.lockingMech?.name !== '' || ap?.configuration?.value === 6) && (
                    <FlexColumn alignItems="start">
                        <FlexColumn>
                            <FlexRow gap="0" justifyContent="start">
                                <Typography variant={"b1R"} color={colors.grey900}>{ap?.configuration.value === 6 ? 'Door open duration' : 'Relay on Time'}</Typography>

                                <FlexRow flexWrap="nowrap" width="fit-content">
                                    <FlexColumn>
                                        <TextInput
                                            name=""
                                            value={ap?.relayTime}
                                            type={'number'}
                                            min="1"
                                            max="240"
                                            onChange={(e) => {
                                                if (e.target.value <= 0) {
                                                    hUpdateForm("relayTimeError", 'Relay time cannot be set to 0')
                                                } else {
                                                    hUpdateForm("relayTimeError", '')
                                                }
                                                setRelayValue(e.target.value);
                                            }}
                                        />
                                        <Typography variant={"b3R"} color={colors.info500}>Allowed range is 1-240 seconds.</Typography>
                                    </FlexColumn>
                                    <Typography variant={"b1R"} color={colors.grey900}>Seconds</Typography>
                                </FlexRow>
                            </FlexRow>
                        </FlexColumn>
                        {ap?.relayTimeError !== '' ? (
                            <Typography variant={"b2R"} color={colors.error700}>
                                {ap?.relayTimeError}
                            </Typography>
                        ) : (
                            <></>
                        )}

                        {ap?.configuration?.value !== 6 && (
                            <>
                                <FlexColumn>
                                    <FlexRow flexWrap="nowrap" justifyContent="start">
                                        <Typography variant={"b1R"} color={colors.grey900}>Invert relay logic</Typography>
                                        <Switch
                                            checked={ap?.inveteredRelayLogic}
                                            onChange={() => { hUpdateForm("inveteredRelayLogic", !ap?.inveteredRelayLogic) }}
                                        />
                                    </FlexRow>
                                </FlexColumn>
                                <Typography variant={"b3R"} color={colors.error500}>
                                    Enabling this changes the logic of the relay and you will have to wire fail-safe
                                    <span style={{ display: 'block' }}>locks to NO and fail-secure to NC. This will unlock the doors if the Spintly reader/controller fails.</span>
                                </Typography>
                            </>
                        )}
                    </FlexColumn>
                )}
            </FlexColumn>
        );
    }, [
        ap?.toggleRelaytime,
        ap?.relayTime,
        ap?.inveteredRelayLogic,
        ap?.configuration,
        ap?.lockingMech,
        setRelayValue,
        ap?.relayTimeError,
    ]);

    const hUpdateForm = (name, value, isChannel) => {
        setDoors(prev => ({
            ...prev,
            [ap?.id]: {
                ...prev[ap?.id],
                [name]: value
            }
        }))
    }

    const toggleOpen = () => {
        setDoors(prev => ({
            ...prev,
            [ap?.id]: {
                ...prev[ap?.id],
                opened: !prev?.[ap?.id]?.opened
            }
        }))
    }

    const hDeleteDoor = () => {
        updateChannel("", true);
        updateChannel("", false);
        setDoors(prev => {
            const { [ap?.id]: _, ...rest } = prev;
            return rest;
        });
    }

    const checkChannelError = (data) => {
        let error = '';
        const allDoorsTemp = Object.values(allDoors);
        for (let i = 0; i < allDoorsTemp?.length; i++) {
            const selectedDoor = allDoorsTemp[i];
            if (selectedDoor?.entryDeviceSerialNum?.channel === data) {
                error = `Channel Already selected for Door ${i + 1} Entry Reader`;
                break;
            }

            if (selectedDoor?.exitDeviceSerialNum?.channel === data) {
                error = `Channel Already selected for Door ${i + 1} Exit Reader`;
                break;
            }
        }

        return error
    }

    const updateChannel = (data, isEntry = true) => {
        const prevChannel = isEntry ? ap?.entryDeviceSerialNum?.channel : ap?.exitDeviceSerialNum?.channel;
        const toAdd = `${isEntry ? 'En' : 'Ex'}${ap?.id}`
        setChannelsMap(prev => {
            const toReturn = {
                ...prev,
            }

            if (data) {
                toReturn[data] = prev?.[data] ? [...prev?.[data], toAdd] : [toAdd]
            }

            if (prevChannel && data !== prevChannel) {
                toReturn[prevChannel] = [...channelsMap[prevChannel]]?.filter(c => c !== toAdd)
            }

            return toReturn;
        })
    }

    return (
        <FlexColumn alignItems="start" styles={{ background: colors.grey025, padding: '1rem', borderRadius: '0.5rem' }}>
            <FlexColumn gap="0.1rem">
                <FlexRow flexWrap="nowrap">
                    <FlexColumn gap="0.2rem" alignItems="start">
                        <Typography variant="b1SB">Door {doorCount}</Typography>
                        <Typography variant="b3R" color={colors.grey400}>Enter details for door {doorCount}</Typography>
                    </FlexColumn>
                    <SButton variant={"tertiary"} onClick={toggleOpen}>
                        {ap?.opened ? <CaretDownIcon weight="bold" size={24} /> : <CaretUpIcon weight="bold" size={24} />}
                    </SButton>
                </FlexRow>
                <Divider />
            </FlexColumn>

            {ap?.opened &&
                <>
                    <>
                        <TextInput
                            name=""
                            placeholder="Access Point Name"
                            value={ap?.accessPointName}
                            onChange={(e) => {
                                const value = e.target.value;
                                hUpdateForm("accessPointName", value?.trimStart())
                            }}
                        />

                        <Dropdown
                            placeholder="Configuration"
                            value={ap?.configuration?.name}
                            onChange={(data) => {
                                updateChannel("", true);
                                updateChannel("", false);

                                hUpdateForm("configuration", {
                                    name: data.name,
                                    value: data.value,
                                    formOptions: {
                                        entry: data.formOptions.entry,
                                        exit: data.formOptions.exit,
                                        control: data.formOptions.control,
                                        lockingMechanism: data.formOptions.lockingMechanism,
                                        relayTime: data.formOptions.relayTime,
                                        attendanceAvailable: data.formOptions?.attendanceAvailable,
                                        doorSensor: data.formOptions?.doorSensor,
                                    },
                                    skipSerialValidations: !!data?.skipSerialValidations,
                                    validSerials: {
                                        entry: data.validSerials.entry,
                                        exit: data.validSerials.exit,
                                        control: data.validSerials.control,
                                    },
                                    lockingMech: data?.lockingMech,
                                })
                                if (ap?.configuration?.value !== data?.value) {
                                    // setAuxInput({
                                    //     enabled: false,
                                    //     inputType: '2'
                                    // });
                                    hUpdateForm("entryDeviceSerialNum", {
                                        value: '',
                                        description: '',
                                        error: '',
                                        channel: '',
                                        genericReader: false,
                                    });
                                    hUpdateForm("exitDeviceSerialNum", {
                                        value: '',
                                        description: '',
                                        error: '',
                                        channel: '',
                                        genericReader: false,
                                    });
                                }

                                if (data?.value === 4) {
                                    hUpdateForm("supportedAccessType", 28);
                                    hUpdateForm("inProgress", false);
                                } else if (data?.value === 8) {
                                    hUpdateForm("supportedAccessType", 829);
                                    hUpdateForm("inProgress", false);
                                } else {
                                    hUpdateForm("inProgress", true)
                                }

                            }}
                            data={accessPointDetails?.controllerType === "1" ?
                                SPINTLY_CONTROLLER_CONFIGS :
                                accessPointDetails?.controllerType === "2" ?
                                    AZURE_ZKTECO_CONTROLLER_CONFIGS :
                                    accessPointDetails?.controllerType === "5" ?
                                        ISTAR_CONTROLLER_CONFIGS :
                                        accessPointDetails?.controllerType === "6" ?
                                            DCS_CONTROLLER_CONFIGS :
                                            OTHERS_CONTROLLER_CONFIGS
                            }
                        />
                    </>

                    <Divider />

                    <>
                        <Dropdown
                            key={ap?.entryDeviceSerialNum?.channel + "Entry"}
                            placeholder={[4, 8]?.includes(ap?.configuration?.value) ? "Select Channel" : "Select Entry Reader Channel"}
                            value={ap?.entryDeviceSerialNum?.channel || undefined}
                            onChange={(data) => {
                                updateChannel(data, true);
                                hUpdateForm("entryDeviceSerialNum", {
                                    ...ap?.entryDeviceSerialNum,
                                    channel: data,
                                })
                            }}
                            allowClear={true}
                            data={editModeChannelOptions || channelOptions || []}
                            error={channelsMap?.[ap?.entryDeviceSerialNum?.channel]?.length > 1 ? "Channel already selected" : ""}
                        />
                        {(![4, 8]?.includes(ap?.configuration?.value)) && <TextInput
                            name=""
                            maxLength={14}
                            description={ap?.entryDeviceSerialNum?.description}
                            placeholder={"Entry Reader Serial Number"}
                            value={ap?.entryDeviceSerialNum?.value}
                            error={ap?.entryDeviceSerialNum?.error}
                            disabled={ap?.entryDeviceSerialNum?.genericReader}
                            onChange={(e) => handleSerialDescription(e.target.value, 'entry')}
                        />}

                        {/* Reguired In Next Phase */}
                        {/* <FlexRow flexWrap="nowrap" gap="0.5rem">
                            <Checkbox
                                checked={ap?.entryDeviceSerialNum?.genericReader}
                                disabled={ap?.configuration?.value === 10}//DISABLED for ENTRY + EXIT Configuration
                                onChange={(e) => {
                                    const { checked } = e?.target;
                                    let toSet = {
                                        ...ap?.entryDeviceSerialNum,
                                        genericReader: checked,
                                    }
                                    if (checked) {
                                        toSet = {
                                            ...toSet,
                                            value: '',
                                            description: '',
                                            error: ''
                                        }
                                    }
                                    hUpdateForm("entryDeviceSerialNum", toSet, true);
                                    hUpdateForm("inProgress", false);
                                }}
                            />
                            <FlexColumn gap="0.1rem" alignItems="start">
                                <Typography variant="b1SB" color={colors.info500}>Connected to generic reader</Typography>
                                <Typography variant="b3R" color={colors.info500}>Select this if a generic/OTB reader is connected to the channel</Typography>
                            </FlexColumn>
                        </FlexRow> */}
                    </>

                    {ap?.configuration?.value === 10 && <>
                        <Divider />
                        <Dropdown
                            placeholder="Select Exit Reader Channel"
                            value={ap?.exitDeviceSerialNum?.channel || undefined}
                            onChange={(data) => {
                                updateChannel(data, false);
                                hUpdateForm("exitDeviceSerialNum", {
                                    ...ap?.exitDeviceSerialNum,
                                    channel: data
                                }, true)
                            }}
                            data={editModeChannelOptions || channelOptions || []}
                            allowClear={true}
                            error={channelsMap?.[ap?.exitDeviceSerialNum?.channel]?.length > 1 ? "Channel already selected" : ""}
                        />
                        <TextInput
                            name=""
                            maxLength={14}
                            description={ap?.exitDeviceSerialNum?.description}
                            placeholder={"Exit Reader Serial Number"}
                            value={ap?.exitDeviceSerialNum?.value}
                            error={ap?.exitDeviceSerialNum?.error}
                            disabled={ap?.exitDeviceSerialNum?.genericReader}
                            onChange={(e) => handleSerialDescription(e.target.value, 'exit')}
                        />
                        {!(ap?.entryDeviceSerialNum?.genericReader || ap?.exitDeviceSerialNum?.genericReader) && ap?.entryDeviceSerialNum?.value?.substring(0, 4) !==
                            ap?.exitDeviceSerialNum?.value?.substring(0, 4) &&
                            ap?.configuration?.formOptions?.exit && (
                                <Typography variant={"b3R"} color={colors.error500}>Your entry device and exit device serial numbers are not matching</Typography>
                            )}

                        {ap?.entryDeviceSerialNum?.value && ap?.entryDeviceSerialNum?.value === ap?.exitDeviceSerialNum?.value &&
                            ap?.configuration?.formOptions?.exit && (
                                <Typography variant={"b3R"} color={colors.error500}>Your entry device and exit device cannot be the same</Typography>
                            )}

                        {/* Reguired In Next Phase */}
                        {/* <FlexRow flexWrap="nowrap" gap="0.5rem">
                            <Checkbox
                                checked={ap?.exitDeviceSerialNum?.genericReader}
                                disabled={ap?.configuration?.value === 10}//DISABLED for ENTRY + EXIT Configuration
                                onChange={(e) => {
                                    const { checked } = e?.target;
                                    let toSet = {
                                        ...ap?.exitDeviceSerialNum,
                                        genericReader: checked,
                                    }
                                    if (checked) {
                                        toSet = {
                                            ...toSet,
                                            value: '',
                                            description: '',
                                            error: ''
                                        }
                                    }
                                    hUpdateForm("exitDeviceSerialNum", toSet, true);
                                    hUpdateForm("inProgress", false);
                                }}
                            />
                            <FlexColumn gap="0.1rem" alignItems="start">
                                <Typography variant="b1SB" color={colors.info500}>Connected to generic reader</Typography>
                                <Typography variant="b3R" color={colors.info500}>Select this if a generic/OTB reader is connected to the channel</Typography>
                            </FlexColumn>
                        </FlexRow> */}
                    </>}

                    <Divider />

                    {!ap?.entryDeviceSerialNum?.genericReader && <>
                        <Typography variant={"h7SB"} color={colors.info500} style={{ marginBottom: '1rem' }}>Credential Types</Typography>
                        {
                            ap?.inProgress ? <CredentialLoaders /> :
                                <FlexRow justifyContent="start">
                                    {ap?.credTypes?.map(cType => {
                                        return <FlexRow justifyContent="start" gap="0" width="fit-content" flexWrap="nowrap">
                                            <Checkbox
                                                disabled={ap?.credentialNotSupported}
                                                checked={ap?.checkedCredTypes?.[cType?.id]}
                                                onChange={() => {
                                                    hToggleCredTypes(cType?.id, !ap?.checkedCredTypes?.[cType?.id])
                                                }}
                                                name={cType?.id}
                                                style={{ whiteSpace: 'nowrap' }}
                                            />
                                            <Typography style={{ marginTop: '-1rem', whiteSpace: 'nowrap' }} variant={"b3SB"}>{cType?.name}</Typography>
                                        </FlexRow>
                                    })}
                                </FlexRow>
                        }
                    </>}

                    <Divider />

                    <Typography variant={"h7SB"} color={colors.info500}>Door Settings</Typography>

                    {ap?.configuration?.formOptions?.lockingMechanism && (
                        <FlexColumn>
                            <Dropdown
                                placeholder="Locking Mechanism"
                                value={ap?.lockingMech?.name}
                                onChange={selectLockingMechanism}
                                data={ap?.configuration?.lockingMech ? Object?.values(ap?.configuration?.lockingMech) : []}

                            />
                        </FlexColumn>
                    )}
                    {renderRelayTime()}

                    {ap?.configuration?.formOptions?.attendanceAvailable && (
                        <>
                            <Divider />
                            <FlexRow justifyContent="start">
                                <Typography style={{ width: '40%' }} variant={"b3SB"}>Enable Attendance for device</Typography>
                                <Switch
                                    checked={ap?.attendanceEnabled}
                                    onChange={() => hUpdateForm("attendanceEnabled", !ap?.attendanceEnabled)}
                                />
                            </FlexRow>
                        </>
                    )}

                    {ap?.configuration?.formOptions?.doorSensor && !['102C', '1027', '1025', '103D', '102F'].includes((ap?.entryDeviceSerialNum?.value || ap?.exitDeviceSerialNum?.value)?.substring(0, 4)) && //Device Should not be 2DC, 1DC and FR
                        (
                            <>
                                <FlexRow justifyContent="start">
                                    <Typography style={{ width: '40%' }} variant={"b3SB"}>Enable Door Sensors</Typography>
                                    <Switch
                                        checked={ap?.doorSensorEnabled}
                                        onChange={() => hUpdateForm("doorSensorEnabled", !ap?.doorSensorEnabled)}
                                    />
                                </FlexRow>

                                {ap?.doorSensorEnabled &&
                                    <FlexColumn alignItems="start" styles={{ background: colors.grey025, padding: '1rem', borderRadius: '0.5rem' }}>
                                        <Typography variant={"b1R"}>Door Sensor Configuration</Typography>
                                        <FlexRow flexWrap="nowrap" alignItems="start">
                                            <FlexRow gap="0" justifyContent="start">
                                                <Radio
                                                    color="primary"
                                                    value="NO"
                                                    checked={ap?.normallyOpen}
                                                    onChange={() => { hUpdateForm("normallyOpen", true) }}
                                                />
                                                <Typography variant={"b3SB"}>Normally Open (N.O.)</Typography>
                                            </FlexRow>

                                            <FlexRow gap="0" justifyContent="start">
                                                <Radio
                                                    color="primary"
                                                    value="NC"
                                                    checked={!ap?.normallyOpen}
                                                    onChange={() => { hUpdateForm("normallyOpen", false) }}
                                                />
                                                <Typography variant={"b3SB"}>Normally Closed (N.C.)</Typography>
                                            </FlexRow>
                                        </FlexRow>
                                        <Typography variant={"b3R"} color={colors.info500}>Note : Door sensor should be connected to {(ap?.configuration?.value === 3 || [4, 8]?.includes(ap?.configuration?.value)) ? "controller" : ap?.configuration?.value === 7 ? "exit reader" : "entry reader"}</Typography>
                                    </FlexColumn>}
                            </>
                        )}
                </>
            }
            <SButton variant={"tertiary"} color={"error"} onClick={hDeleteDoor}><TrashIcon size={18} style={{ marginRight: '0.5rem' }} />Delete Door</SButton>
        </FlexColumn>
    )
};

export default Door;